export default "__VITE_ASSET__D12Zu$nO__"